export default __webpack_public_path__ + "static/media/emotion-m.eb559205.png";